import lang from "@/views/modules/Examples/language/en";
//import Editor from '@tinymce/tinymce-vue';
export default {
    name: "edit-example",
    components: {
//        'editor': Editor,
    },
    data() {
        return {
            loading: true,
            example: {},
            lang:[],
        }
    },
    mounted() {
        this.getExample();
        this.lang = lang;
    },
    methods: {
        saveExample() {
            const self = this;
            self.loading = true;
            axios.put('api/modules/examples/' + self.$route.params.id, self.example).then(function () {
                self.loading = false;
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data updated correctly').toString(),
                    type: 'success'
                });
            }).catch(function () {
                self.loading = false;
            });
        },
        getExample() {
            const self = this;
            self.loading = true;
             window.currentAction = 'list';
                axios.get('api/modules/examples/' + self.$route.params.id).then(function (response) {
                self.example = response.data;
                self.loading = false;
            }).catch(function () {
                self.loading = false;
            });
        },
        
    }
}